import { normalizeProvider } from "@smithy/core";
import { ProviderError } from "@smithy/property-provider";
export var resolveAwsSdkSigV4AConfig = function resolveAwsSdkSigV4AConfig(config) {
  config.sigv4aSigningRegionSet = normalizeProvider(config.sigv4aSigningRegionSet);
  return config;
};
export var NODE_SIGV4A_CONFIG_OPTIONS = {
  environmentVariableSelector: function environmentVariableSelector(env) {
    if (env.AWS_SIGV4A_SIGNING_REGION_SET) {
      return env.AWS_SIGV4A_SIGNING_REGION_SET.split(",").map(function (_) {
        return _.trim();
      });
    }
    throw new ProviderError("AWS_SIGV4A_SIGNING_REGION_SET not set in env.", {
      tryNextLink: true
    });
  },
  configFileSelector: function configFileSelector(profile) {
    if (profile.sigv4a_signing_region_set) {
      var _profile$sigv4a_signi;
      return ((_profile$sigv4a_signi = profile.sigv4a_signing_region_set) !== null && _profile$sigv4a_signi !== void 0 ? _profile$sigv4a_signi : "").split(",").map(function (_) {
        return _.trim();
      });
    }
    throw new ProviderError("sigv4a_signing_region_set not set in profile.", {
      tryNextLink: true
    });
  },
  default: undefined
};